export const travelRouting = [
  {
    path: "/attendance/travel/list",
    name: "attendance-travel-list",
    meta: { title: "出差申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-travel" */ "@/views/attendance-management/travel-application/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/travel/create",
    name: "attendance-travel-create",
    meta: { title: "新建出差申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-travel" */ "@/views/attendance-management/travel-application/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/travel/edit/:id",
    name: "attendance-travel-edit",
    meta: { title: "编辑出差申请" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-travel" */ "@/views/attendance-management/travel-application/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/travel/detail/:id",
    name: "attendance-travel-detail",
    meta: { title: "出差申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-travel" */ "@/views/attendance-management/travel-application/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/attendance/travel/flowPrint/:id",
    name: "attendance-travel-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "attendance-overtime" */ "@/views/attendance-management/travel-application/flow-print/index.vue"
        ),
  },
];
